export enum ValuationEventTypeEnum {
  ManualQuoteAdded,
  ManualQuoteModal
}
